import React from 'react';
import { Box } from '@chakra-ui/react';
import Loader from '../Loader/Loader.tsx';

const fallbackStyle = {
  position: 'fixed' as any,
  top: '0',
  left: '0',
  width: '100%',
  height: '100%',
  backgroundColor: 'background.loader',
  zIndex: '9999', // Ensure it's on top of everything
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export default function Fallback() {
  return (
    <Box style={fallbackStyle}>
      <Loader></Loader>
    </Box>
  );
}
